import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

export const useAgentContext = (currentTab: string) => {
  useRegisterAgentContext({
    kind: 'form',
    description: 'Edit profile form with tabbed sections for personal information',
    data: {
      currentTab,
    },
  });
};
